module.exports = __webpack_public_path__ + "img/IMG_1444_L_WoodMatted_MockedUp.5c898a2d.jpg";